export default __webpack_public_path__ + "static/media/ordersActive.55c313b2.svg";